import React, { useState, useEffect, useCallback } from 'react';
import { useParams } from 'react-router-dom';
import InfiniteScroll from 'react-infinite-scroll-component';
import { supabase } from '../utils/supabaseClient.js';
import SEO from './SEO.js';
import ProductBox from './ProductBox.js';
import ProductSkeleton from './ProductSkeleton.js';

const BrandPage = () => {
  const { brandName } = useParams();
  const [products, setProducts] = useState([]);
  const [hasMore, setHasMore] = useState(true);
  const [page, setPage] = useState(0);
  const PER_PAGE = 12;

  const loadProducts = useCallback(async () => {
    try {
      const from = page * PER_PAGE;
      const to = from + PER_PAGE - 1;

      const { data, error } = await supabase
        .from('products')
        .select('*')
        .eq('brand', brandName) // FILTER BY BRAND
        .range(from, to)
        .order('id', { ascending: true });

      if (error) throw error;
      if (data.length === 0) setHasMore(false);
      
      const mapped = data.map(p => ({
        ...p, name: p.title, imageUrls: p.image_urls || [], keywords: p.keywords || []
      }));

      setProducts(prev => [...prev, ...mapped]);
    } catch (err) { console.error(err); }
  }, [page, brandName]);

  useEffect(() => {
    setProducts([]);
    setPage(0);
    setHasMore(true);
    loadProducts();
  }, [brandName]);

  useEffect(() => { if (page > 0) loadProducts(); }, [page, loadProducts]);

  return (
    <div className="container mt-5">
      <SEO title={`${brandName} Products`} />
      <h1 className="mb-4">Brand: {brandName}</h1>
      <InfiniteScroll
        dataLength={products.length}
        next={() => setPage(p => p + 1)}
        hasMore={hasMore}
        loader={<div className="row">{[...Array(4)].map((_, i) => <ProductSkeleton key={i} />)}</div>}
      >
        <div className="row">
          {products.map(p => <ProductBox key={p.id} product={p} />)}
        </div>
      </InfiniteScroll>
      {products.length === 0 && <div className="alert alert-warning">No products found for this brand.</div>}
    </div>
  );
};

export default BrandPage;